import { useMemo, useCallback } from 'react';

import * as helpers from '../helpers';
import { useGetConfig } from './useGetConfig';

export const useNumberFormatter = () => {
    const getConfig = useGetConfig();

    const formatNumber = useCallback((number, options, locale) => {
        const opts = {
            ...getConfig(options?.locale || locale).number,
            ...options
        };

        return helpers.formatNumber(number, opts);
    }, [getConfig]);

    return useMemo(() => ({
        formatNumber,
        delocalizeNumber: helpers.delocalizeNumber
    }), [formatNumber]);
};

